import { apiRootURL } from "./defaultSettings";
export const DOCUMENT_TITLE = "HUB Marketing by IDLP";

export const PROXY_PORT = {
    Opel: 3001,
    "07ZR": 3002,
    Michelin: 3003,
    Ford: 3004,
    RRG: 3005,
    GtEstimate: 8889,
};

export const dockApps = [
    "citroen",
    "ds",
    "opel",
    "peugeot",
    "misterauto",
    "eurorepar",
    "actia",
];
export const PROXY_DATABOX_URL = "https://proxy-data-box.ia.parts";
export const iframes = {
    citroen: "https://www.citroen.fr/accueil.html",
    ds: "https://www.dsautomobiles.fr/accueil.html",
    eurorepar: "https://www.eurorepar.fr/",
    misterauto: "https://www.mister-auto.com/",
    opel: process.env.REACT_APP_PROXY_SERVER_HOST + ":" + PROXY_PORT.Opel,
    peugeot: "https://www.peugeot.fr/accueil.html",
    actia: "https://www.actia.com/fr",
    back: "https://back.ia.parts/",
    diag: "https://box.ia.parts/",
    erp: "https://idlp.group",
    store: "https://idlp.group",
    visio: "https://meetbox.fr",
    com: "https://idlp.group",
    help: "https://idlp.group",
    tecrmi: "https://rmi.ia.parts",
};

export const iframePartSelector = {
    fr: "https://wp.n.parts/idlp/?r3d=sample-novalt",
    en: "https://wp.n.parts/idlp/?r3d=sample-novalt",
};

export const iframeCarSelector = {
    fr: "https://idlp.group",
    en: "https://idlp.group",
};

export const iframeContactSelector = {
    fr: "https://idlp-cloudio.n.parts",
    en: "https://idlp-cloudio.n.parts",
};

export const iframeStatsSelector: Record<string, string> = {
    fr: "https://idlp.group",
    en: "https://idlp.group",
};

export const DIAG_OTHER_BRANDS = [
    { name: "C@iA", url: "https://www.alternative-autoparts.fr/#ppx7" },
    { name: "C@iA", url: "https://www.alternative-autoparts.fr/#ppx7" },
    { name: "C@iA", url: "https://www.alternative-autoparts.fr/#ppx7" },
    { name: "C@iA", url: "https://www.alternative-autoparts.fr/#ppx7" },
];

export const PLUS_MENU_APPS = [
    {
        id: 0,
        name: "C@iA",
        url: "https://www.alternative-autoparts.fr/#ppx7",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
    {
        id: 1,
        name: "C@iA",
        url: "https://www.alternative-autoparts.fr/#ppx7",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
    {
        id: 2,
        name: "C@iA",
        url: "https://www.alternative-autoparts.fr/#ppx7",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
];

export const WORDPRESS_URL = "https://wp.n.parts/idlp";
type RseSlide = { iframeURL?: string; imgSrc: string };

const WP_CONTENT_PATH = "https://wp.n.parts/idlp/wp-content/uploads";
export const RSE_SLIDES: RseSlide[] = [
    {
        iframeURL: "https://idlp.group",
        imgSrc: `${WP_CONTENT_PATH}/2021/09/EMAIL-PARTIE-MARKETING-HUB-optimisee-web.jpg`,
    },
    {
        iframeURL:
            "https://wp.n.parts/idlp/?r3d=le-magby-groupe-idlp-novembre-2021",
        imgSrc: `${WP_CONTENT_PATH}/2021/09/LOGO-visuel-mag-apps.png`,
    },
    {
        iframeURL:
            "https://wp.n.parts/idlp/?r3d=produits-saison-hiver-2021-2022",
        imgSrc: `${WP_CONTENT_PATH}/2021/09/PRODUIT-SAISON-HIVER-2021-2022-optimisee-web.jpg`,
    },
];

export const USE_KEYCLOAK = true;

export const CART_TABS = [];

export const LEVAM_URL = "https://oem1.ia.parts/oem_idlp.html";

export const showWPSearchBar = false;
